/* Reference Topbar (ported from vault-app), wired to our VaultCtx. Avatar initials real. */
import { useApp } from "./ctx";
import Ic from "./Ic";

const LOGO = `
  <defs>
    <linearGradient id="lgSilver" x1="0" y1="0" x2=".6" y2="1"><stop offset="0" stop-color="#F5F6F7"/><stop offset=".5" stop-color="#C4C9CF"/><stop offset="1" stop-color="#8F959D"/></linearGradient>
    <linearGradient id="lgGoldE" x1="0" y1="0" x2=".5" y2="1"><stop offset="0" stop-color="#E9CF95"/><stop offset=".55" stop-color="#C7A05C"/><stop offset="1" stop-color="#93703A"/></linearGradient>
    <linearGradient id="lgGoldJ" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#E7CD92"/><stop offset=".45" stop-color="#C4A163"/><stop offset="1" stop-color="#8F6D38"/></linearGradient>
  </defs>
  <g fill="none" stroke-linejoin="round" stroke-linecap="round">
    <path d="M42,196 L170,64 H470 L598,196 L320,546 Z" stroke="url(#lgSilver)" stroke-width="16"/>
    <path d="M84,202 L196,94 H444 L556,202 L320,496 Z" stroke="url(#lgGoldE)" stroke-width="8" opacity=".9"/>
    <path d="M42,196 H232 M408,196 H598" stroke="url(#lgSilver)" stroke-width="14"/>
    <path d="M170,64 L262,196 L186,292" stroke="url(#lgSilver)" stroke-width="11"/>
    <path d="M470,64 L378,196 L454,292" stroke="url(#lgSilver)" stroke-width="11"/>
  </g>
  <text x="330" y="428" text-anchor="middle" font-family="Times New Roman,Times,serif" font-size="460" font-weight="bold" fill="url(#lgGoldJ)">J</text>`;

export default function Topbar({ avatar = "?", avatarTitle = "Account", onAvatar }: {
  avatar?: string; avatarTitle?: string; onAvatar?: () => void;
}) {
  const { open, navOpen, setNavOpen, go } = useApp();
  return (
    <header className="topbar">
      <button className="menu-btn" title="Menu" onClick={() => setNavOpen(!navOpen)}><Ic n="menu" size={19} /></button>
      <button
        className="brand"
        title="Home"
        onClick={() => go("home")}
        style={{ background: "none", border: "none", padding: 0, font: "inherit", color: "inherit", cursor: "pointer", textAlign: "left" }}
      >
        <div className="logo-mark" style={{ background: "none", boxShadow: "none", width: 40, height: 38 }}>
          <svg width="38" height="34" viewBox="0 0 640 570" dangerouslySetInnerHTML={{ __html: LOGO }} />
        </div>
        <div><div className="name">Vault</div></div>
      </button>
      <div className="search">
        <svg className="s-ico" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></svg>
        <input type="text" placeholder={'Search models, renders, stones, SKUs… (e.g. "solitaire 1.5ct rose gold")'} onFocus={(e) => { e.currentTarget.blur(); open("cmdk"); }} readOnly />
        <span className="kbd-hint" onClick={() => open("cmdk")}><span className="kbd">Ctrl</span><span className="kbd">K</span></span>
      </div>
      <div className="spacer"></div>
      <button className="icon-btn search-mini" title="Search" onClick={() => open("cmdk")}><Ic n="search" size={19} /></button>
      <button className="icon-btn" title="Render queue" onClick={() => open("queue")}><Ic n="monitor" size={19} /></button>
      <button className="icon-btn" title="Activity" onClick={() => open("activity")}><Ic n="bell" size={19} /></button>
      <div className="avatar" title={avatarTitle} onClick={onAvatar} style={onAvatar ? { cursor: "pointer" } : undefined}>{avatar}</div>
    </header>
  );
}
